import React, { useState, useEffect, useRef, useMemo } from "react";
import ReactPlayer from "react-player";
import axios from "axios";
import {
  Grid,
  Box,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import {
  ChevronLeft,
  ChevronRight,
  Close as CloseIcon,
} from "@mui/icons-material";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

function CctvPage() {
  const [searchQuery, setSearchQuery] = useState("");
  const [layout, setLayout] = useState("3x3");
  const [currentPage, setCurrentPage] = useState(1);
  const [isLayoutDialogOpen, setIsLayoutDialogOpen] = useState(false);
  const [tempLayout, setTempLayout] = useState(layout);
  const [playingStates, setPlayingStates] = useState({});
  // const [hoveredCamera, setHoveredCamera] = useState(null);

  // เพิ่ม state ที่ขาด
  const [cameras, setCameras] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // สำหรับ mock stream URL (หากมี)
  const [streamUrl1, setStreamUrl1] = useState(null);
  const [streamUrl2, setStreamUrl2] = useState(null);

  useEffect(() => {
    const fetchCameras = async () => {
      const branchName = sessionStorage.getItem("selectedBranch") || "";

      if (!branchName) return;

      setIsLoading(true);
      setError(null);

      try {
        const response = await axios.post(
          `${import.meta.env.VITE_API_URL}/get-branch-cameras`,
          {
            branch_name: branchName,
          }
        );

        if (response.data.success && response.data.cameras) {
          setCameras(response.data.cameras);
        } else {
          setError(response.data.message || "ไม่สามารถโหลดข้อมูลกล้องได้");
          setCameras([]);
        }
      } catch (error) {
        console.error("Error fetching cameras:", error);
        setError("เกิดข้อผิดพลาดในการโหลดข้อมูลกล้อง");
        setCameras([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCameras();
  }, []);

  const videos = useMemo(() => {
    // ถ้าไม่มีกล้อง ให้ใช้จอเปล่า 9 ช่อง
    return cameras.length > 0
      ? cameras.map((camera) => {
          try {
            // ตรวจสอบว่าค่าที่จำเป็นไม่เป็น undefined หรือ null
            if (!camera.hls_protocal || !camera.hls_host || !camera.rtmp_port || 
                !camera.rtmp_app || !camera.hls_stream) {
              console.error('Missing camera URL components:', {
                protocol: camera.hls_protocal,
                host: camera.hls_host,
                port: camera.rtmp_port,
                app: camera.rtmp_app,
                stream: camera.hls_stream
              });
            }
  
            const videoUrl = `${camera.hls_protocal}://${camera.hls_host}:${camera.rtmp_port}/${camera.rtmp_app}/${camera.hls_stream}`;
  
            console.log("Final Video URL:", videoUrl);
  
            return {
              type: "camera",
              label: `กล้อง ${camera.name} จากเสา ${camera.pole_name}`,
              video: videoUrl,
            };
          } catch (error) {
            console.error("Error creating video URL:", error);
            return {
              type: "error",
              label: `${camera.name || "Error"} `,
              video: "",
            };
          }
        })
      : Array(9)
          .fill()
          .map(() => ({
            type: "empty",
            label: "",
            video: "",
          }));
  }, [cameras, streamUrl1, streamUrl2]);

  const camerasPerPage = useMemo(() => {
    const [rows, cols] = layout.split("x").map(Number);
    return rows * cols;
  }, [layout]);

  const totalPages = useMemo(
    () => Math.ceil(videos.length / camerasPerPage),
    [videos.length, camerasPerPage]
  );

  /* 
  // PTZ control function - commented out
  const handlePTZControl = async (cameraId, x, y, zoom) => {
    try {
      await axios.post(
        `${import.meta.env.VITE_API_URL}/camera${cameraId}/ptz`,
        {
          x,
          y,
          zoom,
        }
      );
      console.log(`PTZ control for camera ${cameraId} applied.`);
    } catch (error) {
      console.error(`Error controlling PTZ for camera ${cameraId}:`, error);
    }
  };

  // PTZ controls rendering - commented out
  const renderPTZControls = (cameraId) => (
    <Box
      sx={{
        display: hoveredCamera === cameraId ? "flex" : "none",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
        position: "absolute",

        top: "0px",
        left: "0",
        right: "0",
        width: "100%",
        height: "75%",
        transform: "translateX(0)",
        transition: "all 0.3s ease",
        zIndex: 1000,
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 1,
          transform: "translateY(20%)",
        }}
      >
        <IconButton
          onClick={() => handlePTZControl(cameraId, -1, 0, 0)}
          sx={{
            gridColumn: "1",
            gridRow: "2",
            transform: "translateX(0) scale(1.5)",
            opacity: 1,
            animation:
              hoveredCamera === cameraId
                ? `0.5s ease-out forwards slideLeft`
                : "none",
            "@keyframes slideLeft": {
              from: {
                transform: "translateX(-20px)",
                opacity: 0,
              },
              to: {
                transform: "translateX(0)",
                opacity: 1,
              },
            },
          }}
        >
          <ChevronLeftIcon sx={{ fontSize: "1.5rem" }} />
        </IconButton>
        <IconButton
          onClick={() => handlePTZControl(cameraId, 0, 1, 0)}
          sx={{
            gridColumn: "2",
            gridRow: "1",
            transform: "translateY(0) scale(1.5)",
            opacity: 1,
            animation:
              hoveredCamera === cameraId
                ? `0.5s ease-out forwards slideUp`
                : "none",
            "@keyframes slideUp": {
              from: {
                transform: "translateY(-20px)",
                opacity: 0,
              },
              to: {
                transform: "translateY(0)",
                opacity: 1,
              },
            },
          }}
        >
          <KeyboardArrowUpIcon sx={{ fontSize: "1.5rem" }} />
        </IconButton>
        <IconButton
          onClick={() => handlePTZControl(cameraId, 1, 0, 0)}
          sx={{
            gridColumn: "3",
            gridRow: "2",
            transform: "translateX(0) scale(1.5)",
            opacity: 1,
            animation:
              hoveredCamera === cameraId
                ? `0.5s ease-out forwards slideRight`
                : "none",
            "@keyframes slideRight": {
              from: {
                transform: "translateX(20px)",
                opacity: 0,
              },
              to: {
                transform: "translateX(0)",
                opacity: 1,
              },
            },
          }}
        >
          <KeyboardArrowRightIcon sx={{ fontSize: "1.5rem" }} />
        </IconButton>
        <IconButton
          onClick={() => handlePTZControl(cameraId, 0, -1, 0)}
          sx={{
            gridColumn: "2",
            gridRow: "3",
            transform: "translateY(0) scale(1.5)",
            opacity: 1,
            animation:
              hoveredCamera === cameraId
                ? `0.5s ease-out forwards slideDown`
                : "none",
            "@keyframes slideDown": {
              from: {
                transform: "translateY(20px)",
                opacity: 0,
              },
              to: {
                transform: "translateY(0)",
                opacity: 1,
              },
            },
          }}
        >
          <KeyboardArrowDownIcon sx={{ fontSize: "1.5rem" }} />
        </IconButton>
      </Box>
    </Box>
  );
  */

  useEffect(() => {
    const adjustVideoHeight = () => {
      const mainContent = document.querySelector(".mainCCtv");
      if (mainContent) {
        const availableHeight = window.innerHeight - mainContent.offsetTop - 20;
        const [rows] = layout.split("x").map(Number);
        const videoHeight = availableHeight / rows - 16;
        document.documentElement.style.setProperty(
          "--video-height",
          `${videoHeight}px`
        );
      }
    };

    adjustVideoHeight();
    window.addEventListener("resize", adjustVideoHeight);

    const initialPlayingStates = {};
    videos.forEach((_, index) => {
      initialPlayingStates[index] = true;
    });
    setPlayingStates(initialPlayingStates);

    return () => {
      window.removeEventListener("resize", adjustVideoHeight);
    };
  }, [layout, videos]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const nextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleOpenLayoutDialog = () => {
    setIsLayoutDialogOpen(true);
    setTempLayout(layout);
  };

  const handleCloseLayoutDialog = () => {
    setIsLayoutDialogOpen(false);
  };

  const handleApplyLayout = () => {
    setLayout(tempLayout);
    setCurrentPage(1);
    setIsLayoutDialogOpen(false);
  };

  const handleLayoutChange = (rows, cols) => {
    const numRows = parseInt(rows, 10);
    const numCols = parseInt(cols, 10);

    if (
      !Number.isNaN(numRows) &&
      !Number.isNaN(numCols) &&
      numRows >= 1 &&
      numRows <= 3 &&
      numCols >= 1 &&
      numCols <= 3
    ) {
      setTempLayout(`${numRows}x${numCols}`);
    }
  };

  const getGridItems = () => {
    const startIndex = (currentPage - 1) * camerasPerPage;
    const endIndex = startIndex + camerasPerPage;
    return videos.slice(startIndex, endIndex);
  };

  const renderVideo = (item, index) => (
    <Box
      // onMouseEnter={() => setHoveredCamera(index + 1)}
      // onMouseLeave={() => setHoveredCamera(null)}
      sx={{
        position: "relative",
        width: "100%",
        height: {
          xs: "250px",
          sm: "250px",
          md: "var(--video-height)",
        },
        bgcolor: "black",
        borderRadius: "6px",
        overflow: "hidden",
        border: "1px solid #667085",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {item.type === "camera" ? (
        <ReactPlayer
          url={item.video}
          playing={true}
          controls={true}
          width="100%"
          height="100%"
          config={{
            rtmp: {
              forceVideo: true,
              scaling: "stretch",
            },
          }}
        />
      ) : (
        // จอเปล่าไม่มีข้อความ
        <Box />
      )}
      {item.type === "camera" && (
        <Typography
          sx={{
            position: "absolute",
            top: 10,
            left: 10,
            color: "white",
            bgcolor: "rgba(0,0,0,0.5)",
            padding: "2px 6px",
            borderRadius: "4px",
          }}
        >
          {item.label}
        </Typography>
      )}
      {/* {item.type === "camera" && renderPTZControls(index + 1)} */}
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ bgcolor: "#1D2430" }}>
        <Toolbar></Toolbar>
      </AppBar>
      <Box sx={{ p: 2, bgcolor: "#1D2430", color: "white" }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item sx={{ mt: { xs: 3, sm: 0 } }}>
            <Typography variant="h6">กล้อง CCTV</Typography>
          </Grid>
          <Grid item sx={{ display: { xs: "none", sm: "block" } }}>
            <Button
              variant="outlined"
              color="inherit"
              onClick={handleOpenLayoutDialog}
            >
              รูปแบบการแสดงผล: {layout}
            </Button>
          </Grid>
          <Grid item xs>
            <div className="searchBar">
              <input
                type="text"
                placeholder="ค้นหารหัสเสา..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </Grid>
          <Grid item>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <IconButton
                onClick={prevPage}
                disabled={currentPage === 1}
                sx={{
                  color: "white",
                  "&.Mui-disabled": { color: "rgba(255, 255, 255, 0.3)" },
                }}
              >
                <ChevronLeft />
              </IconButton>
              <Typography
                variant="body2"
                sx={{ mx: 2, minWidth: "80px", textAlign: "center" }}
              >
                หน้า {currentPage} จาก {totalPages}
              </Typography>
              <IconButton
                onClick={nextPage}
                disabled={currentPage === totalPages}
                sx={{
                  color: "white",
                  "&.Mui-disabled": { color: "rgba(255, 255, 255, 0.3)" },
                }}
              >
                <ChevronRight />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box className="mainCCtv" sx={{ p: 2, bgcolor: "#344054" }}>
        <Grid container spacing={2}>
          {videos.length > 0 ? (
            getGridItems().map((item, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={12 / Number(layout.split("x")[1])}
                key={index}
              >
                {renderVideo(item, index)}
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Box sx={{ p: 4, textAlign: "center", color: "white" }}>
                <Typography variant="h6">
                  {isLoading
                    ? "กำลังโหลดข้อมูล..."
                    : "ไม่พบข้อมูลกล้องในสาขานี้"}
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
      <Dialog
        open={isLayoutDialogOpen}
        onClose={handleCloseLayoutDialog}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: "#344054",
            color: "#fffff",
            fontWeight: "bold",
            p: 2,
          }}
        >
          ตั้งค่าการแสดงผลกล้อง CCTV
          <IconButton
            aria-label="close"
            onClick={handleCloseLayoutDialog}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "#344054", color: "#fff", p: 3 }}>
          <TextField
            fullWidth
            label="แนวนอน (1 - 3)"
            type="number"
            margin="normal"
            value={tempLayout.split("x")[0] || ""}
            onChange={(e) =>
              handleLayoutChange(e.target.value, tempLayout.split("x")[1] || "")
            }
            InputProps={{
              inputProps: { min: 1, max: 3 },
              style: { color: "#F9FAFB" },
            }}
            InputLabelProps={{ style: { color: "#F9FAFB" } }}
            variant="outlined"
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="แนวตั้ง (1 - 3)"
            type="number"
            margin="normal"
            value={tempLayout.split("x")[1] || ""}
            onChange={(e) =>
              handleLayoutChange(tempLayout.split("x")[0] || "", e.target.value)
            }
            InputProps={{
              inputProps: { min: 1, max: 3 },
              style: { color: "#F9FAFB" },
            }}
            InputLabelProps={{ style: { color: "#F9FAFB" } }}
            variant="outlined"
            sx={{ mb: 3 }}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 2,
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: `repeat(${parseInt(
                  tempLayout.split("x")[1]
                )}, 100px)`,
                gap: 2,
              }}
            >
              {Array.from({
                length:
                  parseInt(tempLayout.split("x")[0]) *
                  parseInt(tempLayout.split("x")[1]),
              }).map((_, index) => (
                <Box
                  key={index}
                  sx={{
                    width: "100px",
                    height: "100px",
                    backgroundColor: "#7DA1FB",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 3,
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                    position: "relative",
                    transition: "background-color 0.3s, transform 0.3s",
                  }}
                >
                  กล้อง {index + 1}
                </Box>
              ))}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            backgroundColor: "#344054",
            color: "#fffff",
            fontWeight: "bold",
            p: 2,
          }}
        >
          <Button
            sx={{
              backgroundColor: "#fff",
              color: "#2762F8",
              borderRadius: "8px",
              height: "50px",
              padding: "0 16px",
              minWidth: "120px",
            }}
            onClick={handleCloseLayoutDialog}
          >
            ยกเลิก
          </Button>
          <Button
            sx={{
              backgroundColor: "#2762F8",
              color: "#FFFFFF",
              borderRadius: "8px",
              height: "50px",
              padding: "0 16px",
              minWidth: "120px",
            }}
            onClick={handleApplyLayout}
            variant="contained"
          >
            ตกลง
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default CctvPage;